import { AxiosInstance, AxiosResponse } from 'axios';

export const FeaturesApi = (http: AxiosInstance) => ({
  isFeatureEnabled: async (feature: string): Promise<AxiosResponse<boolean>> =>
    http.get(`/features/${feature}`),

  getFeatureFlags: async (): Promise<AxiosResponse<Record<string, boolean>>> =>
    http.get(`/features`),
});

export default FeaturesApi;
